import React, { useState } from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import Tooltip from '../../../components/tooltip';
import { submitCompliance, ComplianceType, saveComplianceResult, generateConversationId } from '../../../services/compliance';
import Loading from '../../../components/Loading';
import {
  Container,
  Header,
  BackButton,
  TitleContainer,
  Title,
  Subtitle,
  ContentTitle,
  ContentSubtitle,
  TextAreaContainer,
  TextArea,
  ButtonContainer,
  SaveButton
} from './styles';

export const CopyPaste: React.FC = () => {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleBack = () => {
    navigate('/compliance');
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  };

  const handleSave = async () => {
    if (!text.trim()) return;
    
    setIsLoading(true);
    
    try {
      // Fazer a requisição para a API
      const response = await submitCompliance(
        ComplianceType.COPY_PASTE,
        undefined,
        text
      );
      
      console.log("Resposta da API (copy-paste):", response);
      
      // Extrair texto da resposta ou usar o texto original como fallback
      let resultText = '';
      if (response.content && response.content[0]?.text) {
        resultText = response.content[0].text;
      } else if (response.content && response.content[0]?.complianceForm) {
        resultText = JSON.stringify(response.content[0].complianceForm, null, 2);
      } else {
        resultText = text;
      }

      // Criar dados básicos
      const formData = {
        fullName: "User",
        birthDate: "",
        text: text.substring(0, 100) + (text.length > 100 ? "..." : "")
      };
      
      // Extrair schema se disponível
      const schema = response.content && response.content[0]?.complianceForm?.complianceFormSchema 
        ? response.content[0].complianceForm.complianceFormSchema 
        : null;

      // Preparar state para navegação
      const navigationState = {
        showModal: true,
        modalData: formData,
        completed: true,
        resultContent: resultText,
        apiResponse: response,
        fields: schema,
        dataHasBeenSaved: true,
        isNewSubmission: true
      };
      
      // Sempre navegar para compliance/pending independente do resultado
      navigate('/compliance/pending?full=true', { 
        state: navigationState,
        replace: true
      });
    } catch (error) {
      console.error('Erro ao processar o texto:', error);
      // Mostrar a mensagem específica do erro, se disponível
      const errorMessage = error instanceof Error 
        ? error.message 
        : 'Ocorreu um erro ao processar o texto. Tente novamente.';
      alert(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <Header>
        <Tooltip text="Back to Compliance">
          <BackButton onClick={handleBack}>
            {FiArrowLeft({ className: "icon", size: 30 })}
          </BackButton>
        </Tooltip>
      </Header>

      <TitleContainer>
        <Title>Copy and Paste</Title>
        <Subtitle>Paste here the text you want to analyze for compliance verification.</Subtitle>

        <ContentTitle>Instructions</ContentTitle>
        <ContentSubtitle>
          Paste the text in the field below, then click "Save" to process the content.
        </ContentSubtitle>

        <TextAreaContainer>
          <TextArea 
            placeholder="Paste your text here..." 
            value={text} 
            onChange={handleChange} 
          />
        </TextAreaContainer>

        <ButtonContainer>
          <SaveButton onClick={handleSave} disabled={!text.trim() || isLoading}>
            {isLoading ? 'Processando...' : 'Submit'}
          </SaveButton>
        </ButtonContainer>
      </TitleContainer>
      
      {isLoading && <Loading />}
    </Container>
  );
};

export default CopyPaste; 